var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJmeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#BE202E;}\r\n\t.st3{opacity:0.35;fill:#BE202E;enable-background:new    ;}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{fill:url(#SVGID_3_);}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:url(#SVGID_7_);}\r\n\t.st10{fill:url(#SVGID_8_);}\r\n\t.st11{fill:url(#SVGID_9_);}\r\n\t.st12{fill:#B0AFB0;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -21001.9727,
    y1: -2978.2244,
    x2: -21001.0371,
    y2: -2977.1316,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F69923"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    style: {
      stopColor: "#F79A23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    style: {
      stopColor: "#E97826"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.4,10.4c-1.1,0.5-3,2.4-5.1,5.1l1.9,3.8c1.3-1.9,3-3.8,4.3-5.4l0.3-0.3l-0.3,0.3c-0.5,0.5-1.9,2.2-4,5.4 c2.2,0,5.1-0.5,7.8-1.1c0.8-4.3-0.8-6.2-0.8-6.2S79.6,9,77.4,10.4L77.4,10.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,32h-0.3H73.9z M71.8,38.7h-0.5H71.8z M58,54.1C58,53.8,58,53.8,58,54.1c0.5-1.4,1.1-2.4,1.4-3.5 c0.5-1.3,1.1-2.4,1.3-3.5c0.5-1.3,1.1-2.4,1.4-3.5c0.5-1.1,1.1-2.4,1.6-3.5c0.5-0.8,0.8-1.9,1.1-2.7c0-0.3,0.3-0.5,0.3-0.8l0.8-1.6 c0.3-0.5,0.5-1.1,0.8-1.4c0-0.3,0.3-0.3,0.3-0.5h-0.3l-0.3-0.3c-0.3,0.8-0.8,1.3-1.1,2.2c-0.3,0.5-0.3,0.8-0.5,1.3 c-0.5,1.1-1.1,2.4-1.6,3.5c-0.5,1.1-1.1,2.4-1.6,3.5c-0.5,1.1-1.1,2.4-1.4,3.5c-0.5,1.1-1.1,2.4-1.3,3.5c-0.5,1.1-1.1,2.4-1.4,3.5 c0,0.3-0.3,0.5-0.3,0.8c-0.3,1.1-0.8,1.9-1.1,2.7l0.3,0.5h0.3C57.2,56.2,57.5,55.2,58,54.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,42.2h-0.8h0.5H70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.7,42.2h-0.8h0.5H70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.2,39h0.5C71.8,38.7,71.5,38.7,71.2,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.2,39h0.5C71.8,38.7,71.5,38.7,71.2,39z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -21019.1934,
    y1: -2978.5923,
    x2: -21012.5273,
    y2: -2978.5923,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.3,29c0.5-1.1,1.3-2.2,1.9-3.2c0.5-1.1,1.3-2.2,1.9-3.2v-0.3c0.5-1.1,1.3-2.2,1.9-3L72,15.5L71.5,16 c-0.5,0.8-1.1,1.6-1.9,2.4c-0.8,0.8-1.3,1.9-2.2,3c-0.5,1.1-1.3,1.9-2.2,3c-0.5,0.8-1.1,1.9-1.6,2.7l2.7,5.1 C67.2,31.1,67.7,30.1,68.3,29L68.3,29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -21017.1934,
    y1: -2976.8713,
    x2: -21013.2207,
    y2: -2976.8713,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    style: {
      stopColor: "#CD2032"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M56.4,58.1c-0.3,1.1-0.8,1.9-1.1,3c0,0.3,0,0.3-0.3,0.5c-0.3,0.5-0.5,1.3-0.8,2.7c0.8,0.3,1.3,1.3,1.9,2.4 c0-1.1-0.5-2.2-1.3-3c3.8,0.3,7-0.8,8.6-3.5c0.3-0.3,0.3-0.5,0.5-0.8c-0.8,1.1-1.6,1.3-3.5,1.3c2.7-1.1,4-2.4,5.1-4.3 c0.3-0.5,0.5-0.8,0.8-1.3c-2.4,2.4-4.9,3-7.8,2.4l-2.2,0.3C56.7,57.9,56.4,57.9,56.4,58.1L56.4,58.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -21018.2637,
    y1: -2978.7092,
    x2: -21011.5957,
    y2: -2978.7092,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.5,53.5c0.5-1.1,0.8-2.4,1.3-3.5c0.5-1.1,0.8-2.4,1.3-3.5c0.5-1.1,1.1-2.4,1.3-3.5c0.5-1.1,1.1-2.4,1.6-3.5 c0.5-1.1,1.1-2.4,1.6-3.5c0.3-0.5,0.3-0.8,0.5-1.3c0.3-0.8,0.8-1.3,1.1-2.2l-2.7-5.1v0.3c-0.5,1.1-1.3,1.9-1.9,3 c-0.5,1.1-1.1,2.2-1.9,3.2c-0.5,0.8-1.1,1.9-1.3,2.7c0,0.3-0.3,0.3-0.3,0.5c-0.5,1.1-1.1,2.4-1.6,3.5c-0.5,1.3-1.1,2.4-1.3,3.5 c0,0.5-0.3,1.3-0.3,1.9c-0.3,0.5-0.3,1.1-0.5,1.6c-0.3,1.3-0.8,2.7-1.1,4l2.7,5.1c0.3-0.8,0.8-1.9,1.1-2.7 C57.2,54.1,57.2,53.8,57.5,53.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -21017.0547,
    y1: -2978.4736,
    x2: -21013.5508,
    y2: -2978.4736,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    style: {
      stopColor: "#CD2032"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.4,51.9l-0.8,4.9v0.3c-0.8-1.3-3-2.7-3-2.7c1.6,2.2,2.7,4.6,3,6.7c-0.8,0.3-1.9,0-3.2-0.5 c1.3,1.3,2.4,1.6,3,1.6c-1.3,0-2.7,1.1-4,1.9c1.9-0.8,3.5-1.1,4.6-0.8C51,68.4,49.4,74.1,47.5,80c0.5-0.3,0.8-0.5,1.1-1.1 c0.3-1.1,2.4-8.1,5.7-17.5c0-0.3,0.3-0.5,0.3-0.8v-0.3c0.3-1.1,0.8-1.9,1.1-3c0-0.3,0.3-0.5,0.3-0.8L53.4,51.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -21018.2637,
    y1: -2976.9724,
    x2: -21011.5957,
    y2: -2976.9724,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.9,32.8c0,0.3-0.3,0.3-0.3,0.5c-0.3,0.5-0.5,1.1-0.8,1.3L65,36.3c0,0.3-0.3,0.5-0.3,0.8 c-0.3,0.8-0.8,1.6-1.1,2.7c-0.5,1.1-1.1,2.2-1.6,3.5c-0.5,1.1-1.1,2.4-1.3,3.5c-0.5,1.1-1.1,2.4-1.3,3.5c-0.5,1.1-0.8,2.2-1.3,3.5 v0.3c-0.5,1.1-0.8,2.4-1.3,3.5l2.2-0.3c2.4-0.3,5.9-2.2,8.1-4.6c1.1-1.1,1.9-2.4,2.7-3.8c0.5-1.1,1.1-2.4,1.9-3.8 c0.5-1.1,1.1-2.4,1.3-3.8c-0.5,0.3-1.3,0.5-1.9,0.8h-0.8c2.4-0.8,3.8-2.7,4.9-4.9c-0.5,0.5-1.6,1.1-3,1.3h-0.5 c0.8-0.3,1.6-0.8,2.2-1.1l0.3-0.3l0.5-0.5l0.3-0.3c0.3-0.3,0.5-0.5,0.5-0.8c0,0,0-0.3,0.3-0.3c0-0.3,0.3-0.3,0.3-0.5 c0.3-0.5,0.5-1.3,0.8-1.9c0-0.3,0.3-0.5,0.3-0.8v-0.3c0-0.3,0.3-0.5,0.3-0.5c0-0.3,0-0.5,0.3-0.8c0.3-0.3-0.3,0-0.3,0.3 c-0.8,0.5-1.9,0.8-3,1.1l1.9-0.3l-2.2,0.3h-0.3L66.9,32.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -21019.291,
    y1: -2977.0801,
    x2: -21012.623,
    y2: -2977.0801,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M74.5,19.3c-0.5,0.8-1.3,1.9-1.9,3v0.3c-0.5,1.1-1.3,2.2-1.9,3.2c-0.5,1.1-1.1,2.2-1.9,3.5l-1.6,3.2l6.7-0.8 c1.9-0.8,2.7-1.6,3.5-3c0.3-0.3,0.5-0.5,0.5-1.1c0.8-1.1,1.3-2.2,1.9-3.5c0.5-1.1,1.1-2.2,1.3-3.2c0.3-0.5,0.5-1.3,0.5-1.9 c0-0.5,0.3-0.8,0.3-1.3C79.9,18.7,76.6,19.3,74.5,19.3L74.5,19.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,42.2h-0.5H70.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.2,42.2h-0.5H70.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -21018.2637,
    y1: -2976.4832,
    x2: -21011.5957,
    y2: -2976.4832,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M70.2,42.2h-0.5H70.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.2,39C71.2,38.7,71.2,39,71.2,39z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.2,39C71.2,38.7,71.2,39,71.2,39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -21007.1367,
    y1: -2976.5173,
    x2: -21007.1367,
    y2: -2976.5173,
    gradientTransform: "matrix(1.8078 -3.8771 3.8771 1.8078 49588.6133 -76026.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.2,39C71.2,38.7,71.2,39,71.2,39z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.4,31.9v1h-0.2v-1h-0.4v-0.2h1v0.2L74.4,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.9,32.1l-0.4,0.6h-0.2l-0.4-0.6v0.8h-0.2v-1.2H75l0.4,0.6l0.4-0.6h0.4v1.2h-0.2L75.9,32.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmeter);
export default __webpack_public_path__ + "static/media/Jmeter.e61092ec6f30d8720e18e5442fcb3aaf.svg";
export { ForwardRef as ReactComponent };